module.exports = {
      id: "add-user-usage",
      viewBox: "0 0 19.034 19.034",
      url: "img/" + "sprite.svg#add-user-usage",
      toString: function () {
        return this.url;
      }
    }